// app/javascript/controllers/snowflake_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    scores: Array,
    stockName: String 
  }

  connect() {
    this.renderChart()
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }

  renderChart() {
    const options = {
      chart: {
        height: 400,
        type: 'radar',
        toolbar: { show: false }
      },
      series: [{
        name: `${this.stockNameValue} Scores`,
        data: this.scoresValue
      }],
      labels: ['Value', 'Strength', 'Growth', 'AI Prediction', 'Sentiment'],
      plotOptions: {
        radar: {
          size: 120,
          polygons: {
            strokeColors: '#e9e9e9',
            fill: {
              colors: ['#f8f8f8', '#fff']
            }
          }
        }
      },
      colors: ['#2E93fA'],
      fill: {
        opacity: 0.4
      },
      markers: {
        size: 6,
        colors: ['#fff'],
        strokeColor: '#2E93fA',
        strokeWidth: 3
      },
      yaxis: {
        min: 0,
        max: 100,
        show: false
      }
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }
}